module.exports = __webpack_public_path__ + "static/media/egg.3fc4832e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/egg.svg
// module id = 1115
// module chunks = 0